module.exports = __webpack_public_path__ + "fonts/Clash-Bold.2b3f188.woff";